export default __webpack_public_path__ + "static/media/krisi_l.b0a57113.jpg";